import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorSnackBarMessage } from "../systemSlice";
import { errorToHandler } from "../../api/error";
import { api } from "api";
import { RootState } from "app/store";

export const fetchLicense = createAsyncThunk(
  "license/fetchLicense",
  async (_, { rejectWithValue, getState, dispatch }) => {
    return api.license
      .license()
      .then((res) => {
        return res.data;
      })
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);

export const setLicense = createAsyncThunk(
  "license/setLicense",
  async (_, { getState, rejectWithValue, dispatch }) => {
    const state = getState() as RootState;

    const jwt = state.setup.jwt;

    return api.license
      .setLicense(
        { jwt: jwt },
        {
          format: "json",
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {})
      .catch((res) => {
        dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
        return rejectWithValue(res);
      });
  },
);

// export const fetchUserDetails = createAsyncThunk(
//   "users/fetchUserDetails",
//   async (userID: string, { rejectWithValue, getState, dispatch }) => {
//     return api.users
//       .userDetails(userID)
//       .then((res) => {
//         return res.data;
//       })
//       .catch((res) => {
//         dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
//         return rejectWithValue(res);
//       });
//   },
// );

// export const deleteUser = createAsyncThunk(
//   "users/deleteUser",
//   async (userID: string, { rejectWithValue, getState, dispatch }) => {
//     return api.users
//       .userDelete(userID)
//       .then()
//       .catch((res) => {
//         dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
//         return rejectWithValue(res);
//       });
//   },
// );

// export const addUser = createAsyncThunk(
//   "users/addUser",
//   async (user: AddUserRequest, { rejectWithValue, getState, dispatch }) => {
//     return api.users
//       .usersAdd(user)
//       .then()
//       .catch((res) => {
//         dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
//         return rejectWithValue(res);
//       });
//   },
// );

// export const editUser = createAsyncThunk(
//   "users/addUser",
//   async (user: any, { rejectWithValue, getState, dispatch }) => {
//     let id = user.id;
//     delete user.id;
//     return api.users
//       .userEdit(id, user)
//       .then()
//       .catch((res) => {
//         console.log(res);
//         dispatch(setErrorSnackBarMessage(errorToHandler(res.error)));
//         return rejectWithValue(res);
//       });
//   },
// );
